import { User } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { DINECENTRAL_FIRESTORE } from "../Firebase.dinecentral";
import { getRemoteEnv } from "../config/remoteEnv";

export interface DineCentralUserData {
  agreeToMarketing: boolean | null;
}

class UserServiceDineCentral {

  public static GetUserData = async (user: User): Promise<DineCentralUserData> => {
    try {
      const userDocRef = doc(DINECENTRAL_FIRESTORE, "users", user.email || user.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        const data = userDocSnap.data();
        const appId = getRemoteEnv().appId;
        // agreeToMarketing is stored at apps[appId].agreeToMarketing
        const agreeToMarketing = data?.apps?.[appId]?.agreeToMarketing ?? null;
        console.log(`DineCentral: agreeToMarketing for appId=${appId}:`, agreeToMarketing);
        return { agreeToMarketing };
      } else {
        console.log("DineCentral: No user document found.");
        return { agreeToMarketing: null };
      }
    } catch (error) {
      console.error("DineCentral: Error fetching user document:", error);
      return { agreeToMarketing: null };
    }
  };

}

export default UserServiceDineCentral;